import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './dataVendorActions.module.scss';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';
import { AxiosError } from 'axios';
import { DataVendor } from 'v2/models';
import ConfirmationModal from 'v2/common/ConfirmationModal/ConfirmationModal';
import { PostProcessKeys, TranslationKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface DataVendorProps {
  dataVendor: DataVendor;
  onChange?: () => void;
}

const DataVendorActions = ({ dataVendor, onChange }: DataVendorProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { mutate: deleteDataVendor, isLoading: isDeleting } = useMutation(
    () => restFactory.delete(`/dj/api/v1/data_vendor/${dataVendor.id}`),
    {
      onSuccess: async () => {
        toast.success(
          `${t(TranslationKeys.dataProvider_other, {
            postProcess: PostProcessKeys.TitleCase,
          })} deleted successfully`
        );
        history.push(`/data-providers/1`);
      },
      onError: (error: AxiosError | string) => {
        const errorMessage =
          typeof error === 'string'
            ? error
            : `An error occurred while deleting the ${t(
                TranslationKeys.dataProvider_one
              )}. Please contact support`;
        toast.error(errorMessage);
      },
      onSettled: () => {
        setShowConfirmationModal(false);
      },
    }
  );

  if (!dataVendor.is_editable && !dataVendor.is_deletable) {
    return null;
  }

  return (
    <>
      <Dropdown
        className="d-inline"
        data-cy="datavendor-details:datavendor-actions-dropdown"
      >
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          variant="link"
          className={classnames('p-0', styles.actionBtn)}
        >
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu data-cy="datavendor-details:datavendor-actions-options">
          {dataVendor.is_editable && (
            <Dropdown.Item onClick={() => onChange?.()}>Edit</Dropdown.Item>
          )}
          {dataVendor.is_deletable && (
            <Dropdown.Item onClick={() => setShowConfirmationModal(true)}>
              Delete
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <ConfirmationModal
        show={showConfirmationModal}
        onCancel={() => setShowConfirmationModal(false)}
        onOk={async () => deleteDataVendor()}
        isLoading={isDeleting}
        okBtnText="Delete"
        title={`Delete ${t(TranslationKeys.dataProvider_one, {
          postProcess: PostProcessKeys.TitleCase,
        })}`}
      >
        <>
          Are you sure you want to delete this{' '}
          {t(TranslationKeys.dataProvider_one)}?
        </>
      </ConfirmationModal>
    </>
  );
};

export default DataVendorActions;
